import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import { Combos_combos_edges_node } from "@saleor/combos/types/Combos";
import { ComboListUrlSortField } from "@saleor/combos/urls";
import AppHeader from "@saleor/components/AppHeader";
import Container from "@saleor/components/Container";
import FilterBar from "@saleor/components/FilterBar";
import PageHeader from "@saleor/components/PageHeader";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import {
  FilterPageProps,
  ListActions,
  PageListProps,
  SortPage,
  TabPageProps
} from "../../../types";
import ComboList from "../ComboList";
import {
  ComboFilterKeys,
  ComboListFilterOpts,
  createFilterStructure
} from "./filters";

export interface ComboTableProps
  extends PageListProps,
    ListActions,
    FilterPageProps<ComboFilterKeys, ComboListFilterOpts>,
    SortPage<ComboListUrlSortField>,
    TabPageProps {
  combos: Combos_combos_edges_node[];
  onBack: () => void;
  toatlCount: number;
}

export const ComboListPage: React.FC<ComboTableProps> = ({
  combos,
  currentTab,
  disabled,
  initialSearch,
  isChecked,
  pageInfo,
  selected,
  settings,
  tabs,
  toggle,
  toggleAll,
  toolbar,
  onAdd,
  onAll,
  onNextPage,
  onPreviousPage,
  onRowClick,
  onSearchChange,
  onTabChange,
  onTabDelete,
  onTabSave,
  onUpdateListSettings,
  toatlCount,
  onBack,
  currencySymbol,
  filterOpts,
  onFilterChange,
  ...listProps
}) => {
  const intl = useIntl();
  const structure = createFilterStructure(intl, filterOpts);

  return (
    <Container>
      <AppHeader onBack={onBack}>
        <FormattedMessage {...sectionNames.configuration} />
      </AppHeader>
      <PageHeader
        title={intl.formatMessage(sectionNames.combo) + "(" + toatlCount + ")"}
      >
        <Button color="primary" variant="contained" onClick={onAdd}>
          <FormattedMessage
            defaultMessage="Create combo"
            description="button"
          />
        </Button>
      </PageHeader>
      <Card>
        <FilterBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All Combos",
            description: "tab name"
          })}
          currencySymbol={currencySymbol}
          currentTab={currentTab}
          filterStructure={structure}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search Combos"
          })}
          tabs={tabs}
          onAll={onAll}
          onFilterChange={onFilterChange}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />
        <ComboList
          combos={combos}
          disabled={disabled}
          isChecked={isChecked}
          pageInfo={pageInfo}
          selected={selected}
          settings={settings}
          toggle={toggle}
          toggleAll={toggleAll}
          toolbar={toolbar}
          onNextPage={onNextPage}
          onPreviousPage={onPreviousPage}
          onRowClick={onRowClick}
          onUpdateListSettings={onUpdateListSettings}
          {...listProps}
        />
      </Card>
    </Container>
  );
};
ComboListPage.displayName = "ComboListPage";
export default ComboListPage;
